// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"socialIcons-module--socialIcons--2vwOm","svgcircle":"socialIcons-module--svgcircle--1ihLI"};